
var debounce = require('lodash.debounce');

import MiniMasonry from "minimasonry";

import bestDeals from '../../components/shop/bestDeals';
import shopifyStoreCard from '../../components/shopify/shopifyStoreCard2';
import shopifyProductCard from '../../components/shopify/shopifyProductCard';
import socialShare from '../../components/socialShare';
import carousel from '../../components/misc/carousel';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

var vue = new Vue({
    el: '#main-wrapper',
    components: {
        shopifyStoreCard,
        shopifyProductCard,
        socialShare,
        carousel,
        bestDeals
    },
    data: {
        search_tag: null,
        selected_tab: '#CategoryProducts',
        products: {
            loading: false,
            data: [],
            groups: [],
            search: '',
            pagination: {
                page: 1,
                per_page: 50,
            },
            match_all_keywords: false,
            load_more: true,
            order_by: 'score',
            order_dir: -1,
            min_price: null,
            max_price: null,
            category: null,
            masonry: null,
            masonry_needs_init: false,
            on_sale: false
        },
        stores: {
            loading: false,
            data: [],
            map: [],
            search: '',
            pagination: {
                page: 1,
                per_page: 40,
            },
            match_all_keywords: false,
            load_more: true,
            order_by: 'score',
            order_dir: -1,
            city: null,
            province: null,
            category: null,
            masonry_needs_init: false
        },
        search_tag_suggestions: {
            loading: false,
            data: [],
            limit: 14,
            total_size: 0
        },
        display_products: false,
        categories: [],
        carousel_options: {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false,
            freeMode: false,
            navigation: {}
        },
        keyword: null,
        keyword_obj: null,
        deals: {
            data: [],
            loading: false,
        },
    },
    computed: {
        sorted_categories: function(){
            return this.categories.sort(function(a, b){
                var a_val = a.name;
                var b_val = b.name;
                if(a_val > b_val){
                    return 1;
                } else if(a_val < b_val){
                    return -1;
                }
                return 0;
            });
        },
        product_search: function(){
            if(!this.search_tag){
                return;
            }
            var search = this.products.search;
            
            if(this.keyword_obj){
                search += ' ' + this.keyword_obj.name || this.keyword_obj.keyword;
            } else if(this.search_tag && this.search_tag.categories.length > 2){
                search += ' ' + this.search_tag.name;
            }
            
            for(var i=0; i < this.search_tag_suggestions.data.length; i++){
                var suggestion = this.search_tag_suggestions.data[i];
                if(suggestion.active){
                    search += ' ' + suggestion.keyword;
                }
            }
            return search;
        },
        category_name: function(){
            var name = '';
            if(this.keyword_obj){
                name = this.keyword_obj.name || this.keyword_obj.keyword;
            }
            if(name){
                var split = name.split(' ');
                split = split.map(function(text){
                    return text[0].toUpperCase() + text.slice(1);
                });
                name = split.join(' ');
                return name;
            }
        },
        product_map: function(){
            var product_map = {};
            var products = this.products.data;
            
            for(var i=0; i < products.length; i++){
                var product = products[i];
                var id = product.id;
                if(!product_map[id]){
                    product_map[id] = 0;
                }
                product_map[id]++;
            }
            
            return product_map;
        }
    },
    created: function () {
        var self = this;
        
        self.display_products = true;
        
        this.search_tag = window.search_tag;
        if(window.categories && window.categories.length){
            this.categories = window.categories;
        }
        
        if(window.keyword){
            this.keyword = window.keyword;
        }
        if(window.keyword_obj){
            this.keyword_obj = window.keyword_obj;
        }
        
        window.addEventListener('resize', this.onResize);
        
        if(window.products){
            //First page has already been loaded
            this.products.data = window.products;
            delete window.products;
            $('#LoadedProductsList').remove();
        }
        this.getDeals();
    },
    mounted: function () {
        var self = this;
        this.initProductsGrid();
        
        if(this.search_tag.keyword_suggestions){
            this.calculateKeywordSizes(this.search_tag.keyword_suggestions);
            this.calculateTagLimit();
        } else {
            this.getShopifyProductKeywordSuggestions();
        }
        
        $('#products-tab').on('shown.bs.tab', function (event) {
            if(self.products.masonry_needs_init){
                self.initMasonryGrid();
                self.calculateTagLimit();
            }
        });
        
        this.initIntersection(document.getElementById('stores'), this.getStores);
        
        this.initPriceRangePicker();
    },
    methods: {
        initPriceRangePicker: function(){
            var self = this;
            var range = document.getElementById('range');
            
            if(!range || !noUiSlider){
                return;
            }
            
            noUiSlider.create(range, {
                start: [0, 1000],
                connect: true,
                step: 1,
                range: {
                    'min': 0,
                    'max': 1000
                }
            });
            
            range.noUiSlider.on('update', function(values, handle, unencoded, tap, positions, noUiSlider){
                var min = unencoded[0];
                var max = unencoded[1];
                self.products.min_price = parseInt(min);
                self.products.max_price = parseInt(max);
            });

        },
        getShopifyProductKeywordSuggestions: function () {
            var self = this;

            self.search_tag_suggestions.loading = true;
            var url = '/api/v5/shopify/products/keyword-suggestions';

//            var search_categories = [];
//            if(this.search_tag.categories){
//                var search_categories = this.search_tag.categories.slice();
//            }
//            if(this.products.category){
//                search_categories.push(this.products.category);
//            }
            var params = {
                search: this.product_search,
                match_all_keywords: this.products.match_all_keywords,
                disable_no_results_fallback: true,
                on_sale: this.products.on_sale,
//                search_categories: search_categories,
            };
            
            if(this.keyword_obj){
                params.main_category = this.keyword_obj.category;
                params.subcategory = this.keyword_obj.subcategory;
//                params.related_keyword = this.keyword_obj.name;
            } else if(this.search_tag){
                var categories = this.search_tag.categories || [];
                var main_category = categories[0];
                var subcategory = categories[1];
                
                if(main_category){
                    params.main_category = main_category;
                }
                if(subcategory){
                    params.subcategory = subcategory;
                }
//                if(this.keyword){
//                    params.related_keyword = this.keyword;
//                }
            }
            
            if(this.products.city){
                params.city = this.products.city;
            }
            if(this.products.province){
                params.province = this.products.province;
            }

            return axios.get(url, {params: params}).then(function (response) {
                var data = response.data.data;

                var suggestions_to_keep = self.search_tag_suggestions.data.filter(function(suggestion){
                    return suggestion.active;
                });
                data = suggestions_to_keep.concat(data);

                self.calculateKeywordSizes(data);
                self.calculateTagLimit();

                self.search_tag_suggestions.loading = false;
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.search_tag_suggestions.loading = false;
                self.showErrorMessage(error);
            });
        },
        addFilterValues: function(params) {
            var num_fields = [
                'min_followers', 'max_followers',
                'min_engagement', 'max_engagement',
                'min_likes', 'max_likes',
                'min_comments', 'max_comments',
            ];
            for (const [key, value] of Object.entries(this.filters)) {

                if(!this.selected_features[key]){
                    continue;
                }

                if (typeof value === 'boolean') {
                    if (value) {
                        params[key] = value;
                    }
                } else {
                    if (num_fields.includes(key) && typeof value === 'string') {
                        params[key] = value.replaceAll(',', '');
                    } else {
                        params[key] = value;
                    }
                }
            }
        },
        getProducts: function(){
            var self = this;
            if (this.products.loading) {
                return;
            }
            self.products.loading = true;
            var url = '/api/v5/shopify/products';

//            var search_categories = this.search_tag.categories.slice();
//            if(this.products.category){
//                search_categories.push(this.products.category);
//            }
            var params = {
                search: this.product_search,
                page: this.products.pagination.page,
                per_page: this.products.pagination.per_page,
                match_all_keywords: this.products.match_all_keywords,
                disable_no_results_fallback: true,
                order_by: this.products.order_by,
//                search_categories: search_categories,
                on_sale: this.products.on_sale
            };
            console.log(params, this.product_search);
            if(this.keyword_obj){
                
                /* 
                var category_breakdown = this.keyword_obj.category_breakdown;
                //Only apply category filters if there's no category breakdown or if the highest category percentage is over 75
                if(!category_breakdown || (category_breakdown.length && category_breakdown[0].percentage >= 75) ){
                    params.main_category = this.keyword_obj.category;
                    params.subcategory = this.keyword_obj.subcategory;
                }
                */
                
                params.main_category = this.keyword_obj.category;
                params.subcategory = this.keyword_obj.subcategory;
            } else if(this.search_tag){
                var categories = this.search_tag.categories || [];
                var main_category = categories[0];
                var subcategory = categories[1];
                
                if(main_category){
                    params.main_category = main_category;
                }
                if(subcategory){
                    params.subcategory = subcategory;
                }
                if(this.keyword){
//                    params.related_keyword = this.keyword;
//                    params.search = this.keyword;
                }
            }
         
            if(this.products.min_price){
                params.min_price = parseFloat(this.products.min_price);
            }
            if(this.products.max_price){
                params.max_price = parseFloat(this.products.max_price);
            }

            if(this.products.city){
                params.city = this.products.city;
            }
            if(this.products.province){
                params.province = this.products.province;
            }
            
            return axios.get(url, {params: params}).then(function (response) {
                if(!self.display_products){
                    //Prepare loading products with javascript
                    self.products.masonry = null;
                    self.display_products = true;
                }
                
                $('#LoadedProductsList').remove();

                var data = response.data.data;
                if (params.page === 1) {
                    self.products.load_more = true;
                    self.products.data = data;
                } else {
                    
                    for(var i=0; i < data.length; i++){
                        var product = data[i];
                        if(!self.product_map[product.id]){
                            self.products.data.push(product);
                        }
                    }
                    
                }

                if(!data.length || data.length < params.per_page) {
                    self.products.load_more = false;
                }
                if(response.data.pagination && params.page === response.data.pagination.last_page){
                    self.products.load_more = false;
                }

                self.products.loading = false;
                self.initProductsGrid();

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.products.loading = false;
            });
        },
        initProductsGrid: function(){
            var self = this;
            if(this.selected_tab === '#CategoryProducts'){
                Vue.nextTick(function(){
                    self.initMasonryGrid();
                });
            } else {
                this.products.masonry_needs_init = true;
            }
        },
        getStores: function(){
            var self = this;
            if (this.stores.loading) {
                return;
            }
            self.stores.loading = true;
            var url = '/api/v5/shopify/stores-v2';
            
//            var search_categories = this.search_tag.categories.slice();
//            if(this.products.category){
//                search_categories.push(this.products.category);
//            }
            var params = {
                search: this.product_search,
                page: this.stores.pagination.page,
                per_page: this.stores.pagination.per_page,
                match_all_keywords: this.stores.match_all_keywords,
                order_by: this.stores.order_by,
//                search_categories: search_categories,
                city: this.stores.city,
                province: this.stores.province,
            };
            
            if(this.keyword_obj){
                params.main_category = this.keyword_obj.category;
                params.subcategory = this.keyword_obj.subcategory;
//                params.related_keyword = this.keyword_obj.name;
            } else if(this.search_tag){
                var categories = this.search_tag.categories || [];
                var main_category = categories[0];
                var subcategory = categories[1];
                
                if(main_category){
                    params.main_category = main_category;
                }
                if(subcategory){
                    params.subcategory = subcategory;
                }
//                if(this.keyword){
//                    params.related_keyword = this.keyword;
//                }
            }

            if(this.stores.city){
                params.city = this.stores.city;
            }
            if(this.stores.province){
                params.province = this.stores.province;
            }

            return axios.get(url, {params: params}).then(function (response) {

                var data = response.data.data;

                if (params.page === 1) {
                    self.stores.load_more = true;
                    self.stores.data = data;
                    var map = {}; //Reset store map
                    for(var i=0; i < data.length; i++){
                        var store = data[i];
                        map[store.id] = 1;
                    }
                    self.stores.map = map;
                } else {
                    //Only add stores that haven't been added yet
                    self.addStores(data);
                }
                
                if(!data.length || data.length < params.per_page) {
                    self.stores.load_more = false;
                }
                if(response.data.pagination && params.page === response.data.pagination.last_page){
                    self.stores.load_more = false;
                }

                self.stores.loading = false;

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.stores.loading = false;
            });
        },
        addStores: function(stores){
            for(var i=0; i < stores.length; i++){
                var store = stores[i];
                this.addStore(store);
            }
        },
        addStore: function(store){
            if(!this.stores.map[store.id]){
                this.stores.data.push(store);
                this.stores.map[store.id] = 1;
            }
        },
        searchProducts: function(){
            this.products.pagination.page = 1;
            this.getProducts().then(function(){
                $('#FilterProductsModal').modal('hide');
            });
            this.getShopifyProductKeywordSuggestions();
        },
        searchAll: function(){
            this.searchProducts();
            this.searchStores();
        },
        debouncedSearchAll: debounce(function(){
            this.searchAll();
        }, 500),
        loadMoreProducts: function(){
            if(this.products.loading || !this.products.load_more){
                return;
            }
            this.products.pagination.page++;
            this.getProducts();
        },
        searchStores: function(){
            this.stores.pagination.page = 1;
            this.getStores().then(function(){
                $('#FilterStoresModal').modal('hide');
            });
        },
        loadMoreStores: function(){
            if(this.stores.loading || !this.stores.load_more){
                return;
            }
            this.stores.pagination.page++;
            this.getStores();
        },
        addKeyword: function (keyword) {
            if(this.products.loading || this.search_tag_suggestions.loading){
                return;
            }
            Vue.set(keyword, 'active', !keyword.active);
            this.searchAll();
        },
        calculateKeywordSizes: function(data){
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            ctx.font = '12px Poppins';
            var word_sizes = [];
            var total_size = 0;

            for(var i=0; i < data.length; i++){
                var keyword = data[i];
                if(typeof keyword === 'object'){
                    obj = keyword;
                } else {
                    var keyword_width = ctx.measureText(keyword).width;
                    var obj = {
                        keyword: keyword,
                        size: Math.max(keyword_width + 26, 54)
                    };
                }

                total_size += obj.size;
                word_sizes.push(obj);
            }
            this.search_tag_suggestions.data = word_sizes;
            this.search_tag_suggestions.total_size = total_size;
        },
        calculateTagLimit: function(){
            var window_width = document.getElementById('KeywordTagsContainer').offsetWidth;
            var reserved_width = 166;
            var available_width = window_width - reserved_width;
            var count = 0;
            for(var i = 0; i < this.search_tag_suggestions.data.length; i++){
                var obj = this.search_tag_suggestions.data[i];
                if(obj.size > available_width){
                    break;
                }
                available_width -= obj.size;
                count++;
            }
            this.search_tag_suggestions.limit = count;
        },
        onResize: debounce(function () {
            this.calculateTagLimit();

            //Masonry will automatically update the layout on resize
            //But if the tab is not active it'll mess up the layout
            //Use a flag to update the layout when going back to the tab
            if(this.selected_tab !== '#CategoryProducts'){
                this.products.masonry_needs_init = true;
            } else {
                this.initMasonryGrid();
            }
            

        }, 250),
        showTab: function(tab){
            this.selected_tab = tab;
//                $(tab).tab('show');
            if(this.selected_tab !== '#CategoryProducts'){
                this.products.masonry_needs_init = true;
            }
        },
        showFilterModal: function(){
            if(this.selected_tab === '#CategoryProducts'){
                $('#FilterProductsModal').modal('show');
            } else if(this.selected_tab === '#stores'){
                $('#FilterStoresModal').modal('show');
            }
        },
        setShowMoreText: function(){
            var el = document.getElementById('CollectionDescription');
            this.has_show_more_text_button = el && el.clientHeight > 24;
        },
        toggleShowMoreText: function(){
            this.show_more_text = !this.show_more_text;
            var html_data = document.getElementById('html');
            if(html_data && this.show_more_text){
                console.log(this.show_more_text);
                document.getElementsByClassName('collection-description style-body-large mb-0')[0].style.maxHeight="100%"
            }
            if(html_data && !this.show_more_text){
                console.log(this.show_more_text);
                document.getElementsByClassName('collection-description style-body-large mb-0 expanded')[0].style.maxHeight="500px"
            }
        },
        clearProductFilters: function(){
            this.products.min_price = null;
            this.products.max_price = null;
            this.products.category = null;
            this.products.on_sale = false;

            this.products.pagination.page = 1;
            this.getProducts().then(function(){
                $('#FilterProductsModal').modal('hide');
            });
            this.getShopifyProductKeywordSuggestions();
        },
        clearStoreFilters: function(){
            this.stores.city = null;
            this.stores.province = null;
            this.stores.category = null;

            this.stores.pagination.page = 1;
            this.getStores().then(function(){
                $('#FilterStoresModal').modal('hide');
            });
        },
        initMasonryGrid: function(){
            var self = this;
            if(this.products.masonry){
                this.products.masonry.layout();
            } else {
//            if(this.products.data.length){
                $('.masonry-grid').addClass('masonry-initialized');
                var masonry = new MiniMasonry({
                    container: '.masonry-grid',
                    baseWidth: 210,
                    minify: false
                });
                self.products.masonry = masonry;
//            }
            }
        },
        formatNumber: function(num){
            if(typeof num === 'number'){
                return num.toLocaleString();
            }
            return num;
        },
        getDeals: function(){
            var self = this;
            self.deals.loading = true;
            var url = '/api/v5/shopify/products';

            var params = {
                on_sale: true,
                per_page: 20,
            };

            if(this.keyword_obj){
                params.main_category = this.keyword_obj.category;
                params.subcategory = this.keyword_obj.subcategory;
            } else if(this.search_tag){
                var categories = this.search_tag.categories || [];
                var main_category = categories[0];
                var subcategory = categories[1];
                
                if(main_category){
                    params.main_category = main_category;
                }
                if(subcategory){
                    params.subcategory = subcategory;
                }
            }
            if(this.keyword){
                params.search = this.keyword;
            }
            axios.get(url, {params: params}).then(function (response) {
                self.deals.loading = false;
                var data = response.data.data;
//                data = data.sort(function(a,b){ 
//                    return a.unit_price - b.unit_price;
//                });
                self.deals.data = data;

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.deals.loading = false;
                self.showErrorMessage(error);
            });
        },
        getPreviousPrice: function(product){
            var previous_price;
            if(product.price_history && product.price_history.length){
                previous_price = product.price_history[product.price_history.length - 1].unit_price;
            } else if(product.last_price_change < 0){
                previous_price = product.unit_price / (1 + product.last_price_change / 100);
            }
            if(previous_price){
                previous_price = this.$options.filters.formatCurrency(previous_price);
            }
            return previous_price;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/views/shop/shopCategories.js